import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useCookies } from 'react-cookie';
import { Card, Col, Row } from '@themesberg/react-bootstrap';
import { getModuleMaintained, getSystemMaintained, setModuleMaintained } from "../controller/api/systemApi";

const MODULES = [
  { id: 'vietlott', label: 'Vietlott (toàn bộ)', hint: 'Khóa cùng lúc Keno, Mega, Power, Max3D, Max3D Pro, Lotto 5/35' },
  { id: 'keno', label: 'Keno', hint: 'Chỉ Keno', parentId: 'vietlott' },
  { id: 'mega', label: 'Mega 6/45', hint: 'Chỉ Mega 6/45', parentId: 'vietlott' },
  { id: 'power', label: 'Power 6/55', hint: 'Chỉ Power 6/55', parentId: 'vietlott' },
  { id: 'max3d', label: 'Max3D', hint: 'Chỉ Max3D', parentId: 'vietlott' },
  { id: 'max3dpro', label: 'Max3D Pro', hint: 'Chỉ Max3D Pro', parentId: 'vietlott' },
  { id: 'lotto535', label: 'Lotto 5/35', hint: 'Chỉ Lotto 5/35', parentId: 'vietlott' },
  { id: 'mua_chung', label: 'Mua chung Vietlott', hint: 'Tạo nhóm và góp mua chung' },
  { id: 'classic_mn', label: 'Kiến thiết Miền Nam', hint: 'Xổ số kiến thiết miền Nam' },
  { id: 'classic_mt', label: 'Kiến thiết Miền Trung', hint: 'Xổ số kiến thiết miền Trung' },
  { id: 'classic_mb', label: 'Kiến thiết Miền Bắc', hint: 'Xổ số kiến thiết miền Bắc' },
  { id: 'loto', label: 'Loto', hint: 'Vé loto' },
]

export default function ModuleMaintainPanel({ moduleIds, refreshKey }) {
  const [cookies] = useCookies(['lottmekong']);
  const [state, setState] = useState({});
  const [systemMaintained, setSystemMaintained] = useState(false);
  const [busyId, setBusyId] = useState('');

  const visibleModules = useMemo(
    () => MODULES.filter((item) => !moduleIds || moduleIds.includes(item.id)),
    [moduleIds]
  )

  const load = useCallback(async () => {
    const [modules, systemOn] = await Promise.all([
      getModuleMaintained(cookies.lottmekong),
      getSystemMaintained(cookies.lottmekong),
    ])
    setSystemMaintained(Boolean(systemOn))
    setState((modules || []).reduce((acc, item) => {
      acc[item.id] = Boolean(item.maintained)
      return acc
    }, {}))
  }, [cookies.lottmekong])

  useEffect(() => {
    load()
  }, [load, refreshKey])

  const onToggle = async (moduleId) => {
    const nextMaintained = !state[moduleId]
    setBusyId(moduleId)
    const modules = await setModuleMaintained(cookies.lottmekong, moduleId, nextMaintained)
    if (modules) {
      setState(modules.reduce((acc, item) => {
        acc[item.id] = Boolean(item.maintained)
        return acc
      }, {}))
    }
    setBusyId('')
  }

  return (
    <Row className="g-3">
      {visibleModules.map((item) => {
        const selfMaintained = Boolean(state[item.id])
        const forcedByParent = Boolean(item.parentId && state[item.parentId])
        const forced = systemMaintained || forcedByParent
        const running = !selfMaintained && !forced
        const statusText = busyId === item.id
          ? 'Đang cập nhật...'
          : systemMaintained
            ? 'Đang bảo trì theo toàn hệ thống'
            : forcedByParent
              ? 'Đang bảo trì theo toàn bộ Vietlott'
              : (selfMaintained ? 'Đang bảo trì' : 'Đang hoạt động')
        return (
          <Col key={item.id} xs={12} md={moduleIds && moduleIds.length === 1 ? 12 : 6}>
            <Card border="light" className="shadow-sm h-100">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start gap-3">
                  <div>
                    <h6 className="mb-1">{item.label}</h6>
                    <div className="small text-muted">{item.hint}</div>
                  </div>
                  <div className="form-check form-switch mb-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`module-maintain-${item.id}`}
                      checked={forced ? false : !selfMaintained}
                      disabled={busyId === item.id || forced}
                      onChange={() => onToggle(item.id)}
                    />
                  </div>
                </div>
                <div className={`mt-3 fw-bold text-${running ? 'success' : 'danger'}`}>
                  {statusText}
                </div>
              </Card.Body>
            </Card>
          </Col>
        )
      })}
    </Row>
  )
}
